import { motion } from 'framer-motion';
import type { FC, ReactNode } from 'react';
import { useRef, useState } from 'react';

import useHandleClose from '../../hooks/use-handle-close';

interface AccordionProps {
  title: string;
  slNo?: string;
  children: ReactNode;
  defaultOpen?: boolean;
}

const Accordion: FC<AccordionProps> = ({
  title,
  children,
  slNo,
  defaultOpen = false,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const ref = useRef<HTMLDivElement>(null);

  useHandleClose(() => {
    if (!defaultOpen) {
      setIsOpen(false);
    }
  }, ref);

  return (
    <div className="shadow-lg rounded-sm mb-3 px-7 py-5" ref={ref}>
      <button
        className="w-full flex justify-between gap-3 items-center p-3 cursor-pointer"
        onClick={() => {
          setIsOpen(!isOpen);
        }}
        type="button"
      >
        <div className="flex items-center space-x-2 text-xl font-bold">
          {slNo ? <span className="font-medium">{slNo}.</span> : null}
          <span className="text-left">{title}</span>
        </div>
      </button>
      <motion.div
        animate={{
          height: isOpen ? 'auto' : 0,
          borderTopWidth: isOpen ? 0.5 : 0,
        }}
        className="overflow-hidden"
        initial={false}
        transition={{ duration: 0.3, ease: 'easeInOut' }}
      >
        <div className="p-3 text-base">{children}</div>
      </motion.div>
    </div>
  );
};

export default Accordion;
